var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5014 15.8333C17.7138 15.8335 17.918 15.9148 18.0725 16.0606C18.2269 16.2064 18.3199 16.4057 18.3323 16.6177C18.3448 16.8298 18.2758 17.0386 18.1395 17.2014C18.0031 17.3643 17.8098 17.469 17.5989 17.4941L17.5014 17.4999H2.50136C2.28896 17.4997 2.08466 17.4184 1.93022 17.2725C1.77577 17.1267 1.68283 16.9275 1.67038 16.7154C1.65793 16.5034 1.72692 16.2946 1.86324 16.1317C1.99957 15.9688 2.19294 15.8642 2.40386 15.8391L2.50136 15.8333H17.5014ZM15.8347 3.33325C16.2552 3.33312 16.6602 3.49192 16.9685 3.77783C17.2768 4.06374 17.4657 4.45562 17.4972 4.87492L17.5014 4.99992V13.3333C17.5015 13.7537 17.3427 14.1587 17.0568 14.467C16.7709 14.7754 16.379 14.9642 15.9597 14.9958L15.8347 14.9999H4.16802C3.74754 15.0001 3.34255 14.8412 3.03423 14.5553C2.72591 14.2694 2.53706 13.8775 2.50552 13.4583L2.50136 13.3333V4.99992C2.50122 4.57944 2.66003 4.17445 2.94594 3.86613C3.23184 3.55781 3.62373 3.36895 4.04302 3.33742L4.16802 3.33325H15.8347Z",
    fill: "#ECB32C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceIcon);
export default __webpack_public_path__ + "static/media/device-icon.d900a883a14d26c04893c3211dfb0278.svg";
export { ForwardRef as ReactComponent };